import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  clearSessionToken,
  inputValidations,
  loadScriptByURL,
  saveSessionToken,
} from '../../utils'
import { loaderService } from '../../services'
import { useAuthService, AuthContext } from '../../hooks'

const recaptchaKey = '6LcgYzUeAAAAAMzXJ7ddC57PNtA0k-stcLituAZE'

function EmergencyMapContainer() {
  const { loginServiceEmergency } = useAuthService()
  const { login } = useContext(AuthContext)
  const [token, setToken] = useState('')
  const [tokenCaptcha, setTokenCaptcha] = useState('')
  const { verify } = useContext(AuthContext)

  const navigate = useNavigate()
  const isSubmitting = useRef(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tParam = urlParams.get('t')
    setToken(tParam)
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
      () => {}
    )
    setTimeout(() => {
      handleSubmit()
    }, 3000)
  }, [])

  useEffect(() => {
    if (tokenCaptcha !== '' && token !== '') {
      onSubmit()
    }
  }, [tokenCaptcha])

  const onSubmit = async (params) => {
    if (isSubmitting.current) {
      return
    }
    isSubmitting.current = true
    loaderService.show()
    clearSessionToken()
    const response = await loginServiceEmergency({
      captcha: tokenCaptcha,
      token: token,
    })

    if (response && response.data && response.data.token) {
      verify(token)
      // Acceso temporal: no queda guardado al cerrar el navegador.
      saveSessionToken(response.data.token, { persist: false })
      navigate('../mapEmergency', {
        replace: true,
        state: {
          valor: response.data.token,
        },
      })
    } else if (response && response.status === 429) {
      alert(
        'Demasiados intentos, por favor espera un momento e intenta de nuevo'
      )
      navigate('../')
    } else if (response && response.status === 403) {
      alert('Error de autenticación, por favor intenta de nuevo más tarde')
      navigate('../')
    } else {
      alert('Tu QR expiró, por favor genera uno nuevo desde la app Trakku')
      navigate('../')
    }
    loaderService.hide()
  }

  const handleSubmit = (event) => {
    if (!window.grecaptcha) {
      return
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(recaptchaKey, { action: 'submit' })
        .then((captchaToken) => {
          setTokenCaptcha(captchaToken)
        })
        .catch((err) => {})
    })
  }

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        backgroundColor: 'black',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <img
        style={{
          height: '100px',
          width: '300px',
        }}
        src="https://storage.googleapis.com/web-tracku-videos/media/banners/7Recurso-13%402x-8.png"
      />
    </div>
  )
}

export default EmergencyMapContainer
